module.exports = __webpack_public_path__ + "static/media/CostOpportunity_Diagram_Mobile_EN.c72d597c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/CostOpportunity_Diagram_Mobile_EN.png
// module id = 573
// module chunks = 0